<script lang="ts" setup>
import MIcon from "../../medicus/MIcon";
import MTooltipBasic from "../../medicus/MTooltipBasic";
import { QBtn } from "quasar";
import { usePromise } from "vue-composable";
import { hasPermission } from "../../../utils/permission";
import { useKeyboardShortcut } from "../../../composables/keyboardShortcut";
import { openModal } from "../../../composables/dialog/drawer";
import { useApp } from "../../../store";
import { ref, watch } from "vue";

defineProps<{ opened?: Boolean }>();

const app = useApp();
const isOpen = ref(false);
useKeyboardShortcut("patient-finder", () => {
  openSearch();
});

function openSearch() {
  // stop multiple openings by click or shortcut, ENG-15095 (partial fix, just Patient Finder atm)
  if (!isOpen.value) {
    isOpen.value = true;
    return openModal("/staff/recent-patients", {
      ariaLabel: "Find a patient",
      ariaLabelledBy: false,
    });
  }
}

const { loading: checkingPermission, result: hasAccess } = usePromise(() =>
  hasPermission("/staff/recent-patients"),
);

watch(
  () => app.isModalOpen,
  () => {
    isOpen.value = app.isModalOpen;
  },
);
</script>

<template>
  <q-btn
    flat
    no-caps
    dense
    data-testid="app-search"
    :disable="checkingPermission || !hasAccess"
    aria-haspopup="dialog"
    :aria-expanded="isOpen"
    :aria-label="!opened ? 'Find a patient' : undefined"
    @click="openSearch"
  >
    <MTooltipBasic v-if="!hasAccess"
      >You don’t have permission to perform this action.</MTooltipBasic
    >
    <m-layout-stack horizontal center full>
      <m-icon name="fa-regular fa-magnifying-glass" />
      <span>Patient Finder</span>
    </m-layout-stack>
  </q-btn>
</template>
<style lang="scss">
.modal-wrapper .app-search-modal.modal {
  background-color: #fff;

  > .modal-header {
    box-shadow: none;
    padding: 10px 21px 0px 21px;

    > .modal-title {
      font-family: Arial, sans-serif;
      font-style: normal;
      font-weight: 700;
      font-size: 18px;
      line-height: 100%;

      margin: auto 0;
    }
  }
}
</style>
